import { StateCreator } from 'zustand';
import { StoreSlices } from '.';

export interface FiltersProps {
  selectedUrlFilterIds: string[];
  setSelectedFilters: (selectedUrlFilterIds: string[]) => void;
  selectedFilters: string[];
  handleResetFilters: (groupFilters: any[]) => void;
}
export interface FiltersSlice extends FiltersProps {}

export const createFiltersSlice =
  (
    initProps?: Partial<FiltersProps>,
  ): StateCreator<
    Partial<StoreSlices>,
    [['zustand/devtools', never], ['zustand/immer', never]],
    [],
    FiltersSlice
  > =>
  () => ({
    selectedUrlFilterIds: initProps?.selectedUrlFilterIds ?? [],
    setSelectedFilters: initProps?.setSelectedFilters,
    selectedFilters: initProps?.selectedFilters ?? [],
    handleResetFilters: initProps?.handleResetFilters,
  });
